import { render, staticRenderFns } from "./ModalMedium.html?vue&type=template&id=c7279c36&scoped=true&"
import script from "./ModalMedium.js?vue&type=script&lang=js&"
export * from "./ModalMedium.js?vue&type=script&lang=js&"
import style0 from "./ModalMedium.scss?vue&type=style&index=0&id=c7279c36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7279c36",
  null
  
)

export default component.exports